import { Environment } from '../services';
import { WixPatternsEssentials } from './wixPatternsEssentials';

export function wixPatternsEnvironment(
  environment: WixPatternsEssentials['environment'],
): Environment {
  const {
    language,
    artifactId = 'cairo-default-artifact-id',
    componentId = artifactId,
    componentName = componentId,
    uiLibVersion,
    providerType,
    msid,
  } = environment;

  return {
    language,
    artifactId,
    componentId,
    componentName,
    uiLibVersion,
    providerType,
    msid,
  };
}
